/** 官网桌面端首屏使用 CDN 托管背景，避免将大图打入站点静态资源。 */
export const PC_BG_IMAGE = 'https://titan-img.meitudata.com/roboneo/image/overseahome/official-web-bg.jpg';

/** 官网移动端首屏使用独立构图的 CDN 背景。 */
export const MOBILE_BG_IMAGE = 'https://titan-img.meitudata.com/roboneo/image/overseahome/official-h5-bg.jpg';
